import { REQUEST_UPLOAD_START } from 'store/sagas'

type Payload = {
  boardId?: number
  file: any
  path?: string
  documentSourceId?: number
  cardId?: number
  onUpload?: (args: any) => void
}

export default (payload: Payload) => async dispatch => {
  const { boardId, file, path, documentSourceId, cardId, onUpload } = payload

  const _onUpload = async ({ url, documentSourceId, elementId }) => {
    if (onUpload) onUpload({ url, documentSourceId, elementId })
  }

  const uploadPayload: any = {
    file,
    path,
    onUpload: _onUpload
  }

  if (cardId) {
    uploadPayload.cardId = cardId
  } else if (documentSourceId) {
    uploadPayload.documentSourceId = documentSourceId
  } else {
    uploadPayload.boardId = boardId
  }

  dispatch({
    type: REQUEST_UPLOAD_START,
    payload: uploadPayload
  })
}
